module.exports = __webpack_public_path__ + "img/icon@2x (1).62756528.png";